import { useEffect, useState } from 'react';
import { Link, NavLink, Routes, Route, Navigate } from 'react-router-dom';
import { api } from '../api/client.js';
import { useAuth } from '../auth/AuthContext.jsx';
import CollectionImport from '../components/CollectionImport.jsx';
import CollectionGrid from '../components/CollectionGrid.jsx';
import MyEventsPage from './MyEventsPage.jsx';
import MyPvpPage from './MyPvpPage.jsx';
import EventBilanzPage from './EventBilanzPage.jsx';
import ZielePage from './ZielePage.jsx';

/**
 * "Dein Bereich" — alles, was von der eigenen Sammlung abhängt, unter einem
 * Dach: die Pokémon selbst und die daraus abgeleitete Event-Empfehlung.
 */
export default function MyAreaPage() {
  const { user, geladen } = useAuth();

  if (!geladen) return <div className="skeleton" style={{ height: 220 }} />;
  if (!user) return <Einladung />;

  return (
    <>
      <section className="hero">
        <span className="hero__tag">Angemeldet als {user.name}</span>
        <h1>Dein Bereich</h1>
      </section>

      {!user.isVerified && (
        <div className="hinweis-kasten">
          <strong>E-Mail noch nicht bestätigt.</strong> Du kannst alles nutzen,
          aber ohne Bestätigung lässt sich dein Passwort nicht zurücksetzen. Der
          Link steckt in der Willkommensmail.
        </div>
      )}

      <nav className="unter-nav">
        <NavLink to="/mein-bereich/pokemon" className={unterLink}>Meine Pokémon</NavLink>
        <NavLink to="/scan" className={unterLink}>Scan</NavLink>
        <NavLink to="/raid-team" className={unterLink}>Raid-Team</NavLink>
        <NavLink to="/statistik" className={unterLink}>Statistik</NavLink>
        <NavLink to="/mein-bereich/pvp" className={unterLink}>PvP-Rangliste</NavLink>
        <NavLink to="/mein-bereich/events" className={unterLink}>Deine Events</NavLink>
        <NavLink to="/mein-bereich/bilanz" className={unterLink}>Event-Bilanz</NavLink>
        <NavLink to="/mein-bereich/ziele" className={unterLink}>Ziele</NavLink>
      </nav>

      <Routes>
        <Route index element={<Navigate to="pokemon" replace />} />
        <Route path="pokemon" element={<MeinePokemon />} />
        <Route path="pvp" element={<MyPvpPage />} />
        <Route path="events" element={<MyEventsPage />} />
        <Route path="bilanz" element={<EventBilanzPage />} />
        <Route path="ziele" element={<ZielePage />} />
        <Route path="*" element={<Navigate to="pokemon" replace />} />
      </Routes>
    </>
  );
}

const unterLink = ({ isActive }) => `unter-nav__link${isActive ? ' unter-nav__link--aktiv' : ''}`;

function MeinePokemon() {
  const [importStand, setImportStand] = useState(0);
  const [importOffen, setImportOffen] = useState(false);
  const [stand, setStand] = useState(null);

  useEffect(() => {
    api.collection.status().then(setStand).catch(() => setStand(null));
  }, [importStand]);

  return (
    <>
      {stand && stand.total > 0 && (
        <p className="gruppe__text">
          {stand.total} Exemplare, {stand.species} Arten.
        </p>
      )}

      <div className="seiten-aktionen">
        <button
          type="button"
          className={`btn ${importOffen ? 'btn--ghost' : 'btn--primary'}`}
          onClick={() => setImportOffen((o) => !o)}
        >
          {importOffen ? 'Schließen' : 'Sammlung importieren'}
        </button>
      </div>

      {importOffen && (
        <CollectionImport
          onImported={() => { setImportStand((n) => n + 1); setImportOffen(false); }}
        />
      )}

      <CollectionGrid neuLaden={importStand} />
    </>
  );
}

function Einladung() {
  return (
    <>
      <section className="hero">
        <span className="hero__tag">Persönlicher Bereich</span>
        <h1>Dein Bereich</h1>
        <p className="hero__sub">
          Lade deine Sammlung hoch, dann sagt dir die Seite, ob sich ein Event
          für <em>dich</em> lohnt — und nicht nur allgemein.
        </p>
      </section>

      <div className="panel" style={{ maxWidth: 480 }}>
        <p style={{ marginBottom: 16 }}>
          Dafür brauchst du ein Konto. Alles andere auf der Seite bleibt ohne
          Anmeldung zugänglich.
        </p>
        <div className="inline">
          <Link to="/konto?weiter=/mein-bereich" className="btn btn--primary">Anmelden</Link>
          <Link to="/konto?neu=1&weiter=/mein-bereich" className="btn btn--ghost">
            Konto anlegen
          </Link>
        </div>
      </div>
    </>
  );
}
